// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react:true*/
import React, {useEffect} from 'react';
import zutil from 'zutil';
import www_util from '../util.js';
import {Top_sites} from '../unblock/top_sites';

// XXX dmitriikup:
// this component should be deleted after implementation
// of a new /access/popular page with cms

export const Access_popular = ()=>{
    const user_country = zutil.get(window, 'hola_opt.user_country');
    useEffect(()=>{
        // @ts-ignore
        www_util.perr({id: 'www_popular_visit'});
    }, []);
    return <Top_sites need_exe add_on_scroll user_country={user_country}/>;
};
